/* eslint-disable */
import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class CommentsManager extends ServiceBase {
  static async createComment(wordText, content) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/comments`
    const response = await YakFetch.fetch(endpoint, 'POST', { body: { word_text: wordText, content: content } });
    await CommentsManager._abortIfUnsuccessful(response);
    const commentData = response.json();
    return commentData;
  }

  static async updateComment(slug, content) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/comments/${ slug }`
    const response = await YakFetch.fetch(endpoint, 'PUT', { body: { content: content } });
    await CommentsManager._abortIfUnsuccessful(response);
    const commentData = response.json();
    return commentData;
  }

  static async deleteComment(slug) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/comments/${ slug }`
    const response = await YakFetch.fetch(endpoint, 'DELETE');
    await CommentsManager._abortIfUnsuccessful(response);
    return true;
  }

  static async forWord(wordText) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/comments/for_word?word_text=${ wordText }`;
    const response = await YakFetch.fetch(endpoint, 'GET');
    await CommentsManager._abortIfUnsuccessful(response);
    const commentsData = await response.json();
    return commentsData;
  }
}



// WEBPACK FOOTER //
// ./src/services/comments_manager.js